var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-avatar',_vm._b({staticClass:"profile-header__avatar mx-auto",attrs:{"size":112}},'base-avatar',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }